import { getTitle } from "../../helpers/getTitle";
import React from 'react';
import ReactDOM from 'react-dom';
import RowDetailPanel from './RowDetailPanel';

export default class RowIdColumnRenderer {
  init(params) {
    this.clickHandler = function clickHandler(e) {
      if (e.shiftKey && params.store.previousRowIndexSelected !== undefined && !params.node.isSelected()) {
        const previousRowIndex = Number(params.store.previousRowIndexSelected) ?? "";
        params.api.forEachNode(function (node, index) {
          if (params.data.uniqueId === node.data.uniqueId) {
            params.store.currentRowIndexSelected = node.rowIndex;
          }
          return 0;
        });
        const currentRowIndex = Number(params.store.currentRowIndexSelected) ?? "";
        const minRowIndex = Math.min(previousRowIndex, currentRowIndex);
        var maxRowIndex = Math.max(previousRowIndex, currentRowIndex);
        let parentDOM = document.getElementById(params.store.gridId);
        for (let i = minRowIndex; i <= maxRowIndex; i++) {
          params.api.forEachNode(function (rowNode, index) {
            if (
              rowNode.data.uniqueId ===
              params.api?.getDisplayedRowAtIndex(i)?.data?.uniqueId
            ) {
              rowNode.setSelected(true, false);
              if (
                parentDOM.querySelectorAll(
                  "input[id='" + rowNode.id + "']"
                )[0] != undefined
              ) {
                parentDOM.querySelectorAll(
                  "input[id='" + rowNode.id + "']"
                )[0].checked = true;
              }
            }
            return 0;
          });
        }
        params.store.addSelectedRecordsCount(
          params.api.getSelectedNodes().length -
            params.store.noOfRecordsSelected
        );
      } else {
        if (e.target.previousElementSibling != null) {
          params.node.setSelected(!params.node.isSelected(), false);
          if (params.node.isSelected()) {
            params.store.addSelectedRecordsCount(1)
          } else {
            params.store.addSelectedRecordsCount(-1);
          }
          e.target.previousElementSibling.checked = params.node.isSelected();
        }
      }
      params.api.clearRangeSelection();
      params.api.forEachNode(function (node, index) {
        if (params?.data?.uniqueId === node?.data?.uniqueId) {
          params.store.previousRowIndexSelected = node.rowIndex;
        }
        return 0;
      });
    }

    this.parentElement = document.createElement('div')
    this.parentElement.className = "d-flex"
    this.parentElement.title = getTitle(params, params.cellMetaData)

    this.checkboxParentElement = document.createElement('div')
    this.checkboxParentElement.className = "custom-control custom-checkbox d-flex align-self-center"
    this.checkboxParentElement.onclick = this.clickHandler

    if (params.value !== "+") {
      this.rowColorElement = document.createElement("div");
      this.rowColorElement.style =
        "height: \
        " +
        (params.node.rowHeight - 20) +
        "px; border-radius: 5px; align-self: center; margin-right: 5px;" +
      //   "border: 3px solid \
      // " +
      //   (params.data &&
      //   params.data.row_bg_color &&
      //   params.data.row_bg_color !== ""
      //     ? params.data.row_bg_color
      //     : "transparent") +
        ";";
      this.parentElement.appendChild(this.rowColorElement);
      this.checkboxElement = document.createElement('input')
      if(params.data){
        this.checkboxElement.id = params.data.uniqueId 
      }   
      this.checkboxElement.type = "checkbox"
      this.checkboxElement.className = params.data?.uniqueId +" custom-control-input rowIdSelection"
      this.checkboxElement.checked = params.node.isSelected()
      this.checkboxElement.onchange = () => { }

      this.labelElement = document.createElement('label')
      this.labelElement.className = "custom-control-label checkbox-pointer"

      this.checkboxParentElement.appendChild(this.checkboxElement)
      this.checkboxParentElement.appendChild(this.labelElement)
    }

    const isSubsheetView = params.store.view?.type == "table" &&
                        params.store.view?.list_id &&
                        params.store.view?.options?.main_list_id &&
                        params.store.view?.list_id != params.store.view?.options?.main_list_id;
    const isMainSheetView = params.store.view?.type == "table" && !isSubsheetView && !params.store?.isSubsheet;

    this.rowIdElement = document.createElement('div')
    this.rowIdElement.className = "d-flex align-items-center"
    this.rowIdElement.style = "width:" + (Number(params.colDef.width) - (params.value === "+" ? 30 : 50)) + "px;\
                              height: "+ (params.node.rowHeight - 5) + "px;\
                              justify-content: left;\
                              margin-left: "+ (params.value === "+" ? 15 : 5) + "px;\
                              cursor: "+ ((!params.store.isSubsheet && isMainSheetView) ? "pointer" : "default") + ";\
                              color: "+ ((params.value === "+" || !isMainSheetView) ? "#212121" : "#4463ff") + ";";
    this.rowIdElement.innerHTML = params.node.data ? params.value : "loading..."

    this.open = false;
    const toggle = () => {
      try {
        if (params.value != "" && params.value != "+" && !isNaN(Number(params.value)) && isMainSheetView) {
          this.open = !this.open;
          const mountNode = document.getElementById("row-detail-root");

          if (!this.open) {
            if (mountNode) {
              try {
                ReactDOM.unmountComponentAtNode(mountNode);
                // mountNode.remove();
                document.removeEventListener('keydown', onKeyDown);
              } catch (err) {
                console.error("Unmount failed:", err);
              }
            }
            return;
          }

          renderPanel();
        }
      } catch (error) {
        console.error("Error in toggle:", error);
      }
    };

    const renderPanel = () => {
      try {
        let mountNode = document.getElementById("row-detail-root");

        if (!mountNode) {
          mountNode = document.createElement("div");
          mountNode.id = "row-detail-root";
          document.body.appendChild(mountNode);
        }

        ReactDOM.render(
          <RowDetailPanel
            params = {params}
            data={params?.node?.data || {}}
            onClose={toggle}
          />,
          mountNode
        );
        document.addEventListener('keydown', onKeyDown);
      } catch (error) {
        console.error("Error in renderPanel:", error);
      }
    };

    const onKeyDown = (e) => {
      if (e.key === 'Escape' && this.open) {
        toggle();
      }
    };
    if (params.value!= "" && params.value != "+" && !isNaN(Number(params.value)) && isMainSheetView) {
      this.rowIdElement.onclick = toggle;
    }

    this.parentElement.appendChild(this.checkboxParentElement)
    this.parentElement.appendChild(this.rowIdElement)
  }

  getGui() {
    return this.parentElement;
  };
}
